import React from 'react'
import ItemsHideOn from 'src/assets/img/house/btn_sort_on.png'
import ItemHideOff from 'src/assets/img/house/btn_sort_off.png'
import PropTypes from 'prop-types'

const HouseHidePlacedItemsButton = ({ isHide, setIsHide }) => {
  return (
    <button onClick={setIsHide} className="hover:scale-105 transition-transform">
      {isHide ? (
        <img src={ItemsHideOn} alt="Hide" className="h-5 xs:h-6" />
      ) : (
        <img src={ItemHideOff} alt="Show" className="h-5 xs:h-6" />
      )}
    </button>
  )
}

HouseHidePlacedItemsButton.propTypes = {
  isHide: PropTypes.bool,
  setIsHide: PropTypes.func
}

export default HouseHidePlacedItemsButton
